import { Button, Col, Form, Input, InputNumber, Row, Select, Typography } from 'antd';
import React, { useEffect } from 'react';

const { Text } = Typography;
const { Option } = Select;

function RemoveCreditsForm(props) {
  const { initialValues, onSubmit, status, type } = props;

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  const promoTypesMenu = [
    {
      value: 'giftCard',
      name: 'Gift Card',
    },
    {
      value: 'referral',
      name: 'Referral',
    }
  ].map((option) => <Option value={option.value}>{option.name}</Option>);


  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}
    >
      <Form.Item
        label="Email"
        name="email"
      >
        <Input disabled={true} />
      </Form.Item>
      <Form.Item
        label="Credit Amount to Deduct"
        name="deductAmount"
        rules={[ { required: true, message: 'Please input amount to be deducted!' }]}
      >
        <InputNumber min={1} defaultValue={initialValues.deductAmount}/>
      </Form.Item>
      <Form.Item
        label="Reason"
        name="reason"
        rules={[ { required: true, message: 'Please input reason for removing credits!' }]}
      >
        <Input defaultValue={initialValues.reason}/>
      </Form.Item>
      <Form.Item
        label="Promo Type To Be Deducted From"
        name="promoType"
        rules={[{ required: true, message: 'Please select promo type!' }]}
      >
        <Select placeholder="Select a Promo Type">{promoTypesMenu}</Select>
      </Form.Item>
      {status.type === 'SUCCESS' ? (
        <Text type="success">Successful!</Text>
      ): status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            Confirm
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default RemoveCreditsForm;
